import { render } from "./AddSubSecondStreamModal.vue?vue&type=template&id=5873db50&scoped=true"
import script from "./AddSubSecondStreamModal.vue?vue&type=script&lang=js"
export * from "./AddSubSecondStreamModal.vue?vue&type=script&lang=js"

import "./AddSubSecondStreamModal.vue?vue&type=style&index=0&id=5873db50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5873db50"]])

export default __exports__